import {
  createApi,
  setApiGetAccessToken,
} from '@wetransfer/transfer/apollo-api/src';
import { isBetaEnv, isLocalEnv } from '@wetransfer/transfer/modules/url';

import { policies as cachePolicies } from './cache';
import { getAllSentTransfersIds } from './sections/transfer/getAllSentTransfersIds';
import { getReceivedTransfers } from './sections/transfer/getReceivedTransfers';
import { getSentTransfers } from './sections/transfer/getSentTransfers';
import { updateTransferPassword } from './sections/transfer/updateTransferPassword';

export const client = createApi({
  url: '/api/graphql',
  includeCredentials: true, // @FIXME
  debug: isLocalEnv() || isBetaEnv(),
  cachePolicies,
});

export const api = {
  getClient: () => client,
  setGetAccessToken: setApiGetAccessToken,
  transfer: {
    getSentTransfers,
    getReceivedTransfers,
    getAllSentTransfersIds,
    updateTransferPassword,
  },
} as const;
